const FileUtil = {
    convertSVGToPNG(svgData) {
        return new Promise((resolve, reject) => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const pngFile = canvas.toDataURL("image/png");
                resolve(pngFile);
            };
            img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
        });
    },

    convertBase64toBlob(b64Data) {
        return fetch(b64Data).then(res => res.blob());
    },

    formatBytes(bytes, decimals = 2) {
        if (!bytes) {
            return "";
        }
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
};

export default FileUtil;
